import fadeInOnIntersection from "./fadeInOnIntersection";
import accordion from "./accordion";
import scrollHeader from "./scrollHeader";
import anchorScroll from "./anchorScroll";
import setHeight from "./setHeight";
import footerAccordion from "./footerAccordion";

window.addEventListener("DOMContentLoaded", () => {
  const FadeIn = new fadeInOnIntersection();
  const Accordion = new accordion();
  const ScrollHeader = new scrollHeader();
  const AnchorScroll = new anchorScroll();
  const SetHeight = new setHeight();
  const FooterAccordion = new footerAccordion();
});
